(function () {
  var selector = [
    '.exn-step',
    '.exn-service-card',
    '.exn-showroom__card',
    '.exn-section-market__card',
    '.exn-theme-grid__card',
    '.exn-lumin-home__card',
    '.exn-lumin-home__badges span',
    '.exn-lumin-home__system-grid article',
    '.exn-lumin-home__feature-list > div',
    '.product-card-wrapper',
    '.card-wrapper',
    '.multicolumn-card',
    '.article-card'
  ].join(',');

  var activeCard = null;
  var lastEvent = null;
  var moveRaf = null;

  function getCard(target) {
    return target && target.closest ? target.closest(selector) : null;
  }

  function prepareCard(card) {
    if (!card || card.dataset.exnGlowReady === 'true') return;
    card.dataset.exnGlowReady = 'true';
    card.classList.add('exn-glow-target');
  }

  function updateGlowPosition() {
    moveRaf = null;
    if (!activeCard || !lastEvent) return;
    var rect = activeCard.getBoundingClientRect();
    var x = ((lastEvent.clientX - rect.left) / rect.width) * 100;
    var y = ((lastEvent.clientY - rect.top) / rect.height) * 100;
    activeCard.style.setProperty('--sx', x + '%');
    activeCard.style.setProperty('--sy', y + '%');
    activeCard.style.setProperty('--glow', '1');
  }

  document.addEventListener('mouseover', function (event) {
    var card = getCard(event.target);
    if (!card || card === activeCard) return;
    if (event.relatedTarget && card.contains(event.relatedTarget)) return;
    prepareCard(card);
    activeCard = card;
    activeCard.style.setProperty('--glow', '1');
  });

  document.addEventListener('mousemove', function (event) {
    var card = getCard(event.target);
    if (!card) return;
    prepareCard(card);
    activeCard = card;
    lastEvent = event;
    if (!moveRaf) moveRaf = requestAnimationFrame(updateGlowPosition);
  }, { passive: true });

  document.addEventListener('mouseout', function (event) {
    if (!activeCard) return;
    if (event.relatedTarget && activeCard.contains(event.relatedTarget)) return;
    activeCard.style.setProperty('--glow', '0');
    activeCard = null;
    lastEvent = null;
  });
})();
